import Layout from "@/components/Layout";
import { Mail } from "lucide-react";

const Support = () => (
  <Layout>
    <div className="container mx-auto max-w-2xl px-4 py-10 space-y-6 text-slate-200">
      <h1 className="text-2xl font-bold text-white">Support</h1>

      <section className="space-y-3">
        <p className="text-sm text-slate-300">
          Questions, feedback, or need help? We're here for you.
        </p>

        <div className="flex items-center gap-2 text-sm">
          <Mail className="h-4 w-4 text-blue-400" />
          <a
            href="mailto:dawnrebecca@live.co.uk"
            className="text-blue-400 hover:text-blue-300 underline"
          >
            dawnrebecca@live.co.uk
          </a>
        </div>

        <p className="text-sm text-slate-400">
          We aim to respond within 48 hours.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Account &amp; data requests</h2>
        <p className="text-sm text-slate-300">
          To request account deletion or data export, email us from the address associated with your account and we'll process it within 30 days.
        </p>
      </section>
    </div>
  </Layout>
);

export default Support;
